<po-input #inputText
[p-label]="labelText"
[p-clean]="true"
[p-placeholder]="placeholder"
[p-icon]="icon"
(p-change)="insertFilterDisclaimer($event)"
[p-no-autocomplete]="true">
</po-input>

<po-disclaimer-group #disclaimerGroup
[p-disclaimers]="disclaimersGroup"
(p-remove)="removeFilterDisclaimer()"
(p-remove-all)="removeAllFilters()">
</po-disclaimer-group>
